/**
 * Jobber CRM Management Page
 * 
 * Comprehensive management interface for Jobber CRM integration
 * including customer sync, job tracking, and invoice management
 */

import React from 'react'
import { JobberManagementContainer } from '@/features/jobber/components'

export default function JobberManagement() {
  return <JobberManagementContainer />
}
